import { createElement as h } from "react"
import { useSelector } from "react-redux"

import Portal from "@cirrus/legacy/features/core/shared/components/portals/index.jsx"

import { NotificationsModel } from "../model/index.js"
import { LoadingNotifications } from "./loading.js"

export const Layer = () =>
  h(
    Portal,
    null,

    h(LoadingNotifications, { list: useSelector(NotificationsModel.state.loading) }),
  )
